import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AddrLink, Card, EmptyState, ErrorState, Pager, SkeletonRows, usePaged } from "@/components/common";
import { fmtNum, timeAgo } from "@/lib/format";
import { usePageTitle } from "@/lib/seo";

export default function BlocksPage() {
  const pager = usePaged((p) => api.get("/blocks", { params: p }).then((r) => r.data), []);
  usePageTitle("Latest Blocks", "Latest blocks produced on Robinhood Chain with gas usage and transaction counts.");

  return (
    <div className="space-y-6 pt-8">
      <div>
        <h1 className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>Blocks</h1>
        <p className="text-sm text-muted-foreground mt-1">Latest blocks produced on Robinhood Chain.</p>
      </div>
      <Card>
        {pager.loading ? <SkeletonRows n={12} /> : pager.error ? <ErrorState /> : !pager.items.length ? <EmptyState /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] uppercase tracking-wider text-muted-foreground border-b">
                  <th className="px-4 py-2.5 font-medium">Block</th>
                  <th className="px-4 py-2.5 font-medium">Age</th>
                  <th className="px-4 py-2.5 font-medium text-right">Txns</th>
                  <th className="px-4 py-2.5 font-medium text-right">Gas Used</th>
                  <th className="px-4 py-2.5 font-medium text-right">Producer</th>
                </tr>
              </thead>
              <tbody>
                {pager.items.map((b) => (
                  <tr key={b.height} className="table-row-hover border-b last:border-0" data-testid="blocks-page-row">
                    <td className="px-4 py-3"><Link to={`/block/${b.height}`} className="font-mono text-xs text-primary hover:underline">#{b.height}</Link></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{timeAgo(b.timestamp)}</td>
                    <td className="px-4 py-3 text-right text-xs">{b.transactions_count ?? 0}</td>
                    <td className="px-4 py-3 text-right font-mono text-xs">{fmtNum(b.gas_used, { maximumFractionDigits: 0 })}</td>
                    <td className="px-4 py-3 text-right"><AddrLink hash={b.miner?.hash} chars={5} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {!pager.loading && pager.items.length > 0 && <Pager pager={pager} />}
      </Card>
    </div>
  );
}
